import {
  Button,
  FormContextWrapper,
  Input,
  Layout,
  useFormValues,
} from '@pimbutton/tast-components-lib';
import forgotPassword from 'actions/password/forgot';
import { useReduxAction } from 'hooks/useReduxAction';
import React, { useEffect, useState } from 'react';
import { useHistory } from 'react-router';
import AuthVisual from '../AuthVisual/AuthVisual';

export default function ForgotPassword() {
  const [cantSend, setCantSend] = useState(true);
  const { formValues, handleChange, errors } = useFormValues({
    email: '',
  });

  const { push } = useHistory();
  const dispatch = useReduxAction();

  function handleSubmit(e: React.FormEvent<HTMLFormElement>) {
    e.preventDefault();
    dispatch(forgotPassword(formValues));
  }

  useEffect(() => {
    if (formValues?.email) return setCantSend(false);
    setCantSend(true);
  }, [formValues?.email]);

  return (
    <Layout
      authVisual={<AuthVisual />}
      title="Wachtwoord vergeten"
      inputs={
        <FormContextWrapper
          onChange={handleChange}
          errors={errors}
          formValues={formValues}
        >
          <Input name="email" placeholder="E-mailadres" label="Email" />
        </FormContextWrapper>
      }
      buttons={
        <>
          <Button fullWidth inactive={cantSend}>
            Verzend reset link
          </Button>
          <Button fullWidth variant="white" onClick={() => push('/inloggen')}>
            Terug naar de login
          </Button>
        </>
      }
      handleSubmit={(e) => handleSubmit(e)}
    />
  );
}
